import React from 'react';
import { Card, CardTitle, CardContent, Typography, Button, CardActions, } from '@one-thd/sui-atomic-components';
import { B2B_HOME_DEPOT_CREDIT_CARDS_PATH } from '../../constants/links';
import { stashLinkEvent } from '../../utils/analytics';
export var HomeDepotCreditCard = function () {
    var cardTitleHeader = (React.createElement(Typography, { height: "tight", variant: "h3", weight: "bold" }, "Home Depot Credit Cards"));
    var onClickLink = function () {
        stashLinkEvent('account dashboard: home depot credit cards: view card offers');
    };
    return (React.createElement(Card, { grow: true, PaperProps: { className: 'sui-flex sui-h-full' } },
        React.createElement(CardTitle, { header: cardTitleHeader, disableActionSpacing: true }),
        React.createElement(CardContent, { className: "sui-flex sui-overflow-hidden sui-flex-row sui-justify-between sui-h-full" },
            React.createElement("div", { className: "sui-flex sui-flex-col" },
                React.createElement(Typography, null, "Sign up for a Home Depot Credit Card or link an existing one to see current balances, view statements and make payments."))),
        React.createElement(CardActions, null,
            React.createElement("a", { href: B2B_HOME_DEPOT_CREDIT_CARDS_PATH, className: "sui-w-full", onClick: onClickLink },
                React.createElement(Button, { fullWidth: true, variant: "secondary" }, "View Card Offers")))));
};
